import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type BuyCreditsModalStore } from 'entities/Billing/ui/BuyCreditsModal'

type IBuyCreditsModalActionsProps = {
  buyCreditsModalStore: BuyCreditsModalStore
}

export const BuyCreditsModalActions: FC<IBuyCreditsModalActionsProps> = observer(
  ({ buyCreditsModalStore }) => {
    const { textSave, handleBuyCredits, disabled, loading } = buyCreditsModalStore

    return (
      <Button
        typeBtn={'contained'}
        text={textSave}
        disabled={disabled}
        loading={loading}
        onClick={() => {
          handleBuyCredits()
        }}
      />
    )
  }
)
